import React from "react";
import { Provider } from "../../types/api";
import { Select, SelectOption } from "../Select";

interface ProvidersFilterProps {
  providers: Provider[];
  selectedProviders: number[];
  onProvidersChange: (providers: number[]) => void;
  onOpen?: () => void;
  onClose?: () => void;
  loading?: boolean;
  width?: number;
}

const ProvidersFilter: React.FC<ProvidersFilterProps> = ({
  providers,
  selectedProviders,
  onProvidersChange,
  onOpen,
  onClose,
  loading = false,
  width = 350,
}) => {
  const handleChange = (value: string | number | (string | number)[]) => {
    const newProviders = Array.isArray(value)
      ? value.map(Number)
      : [Number(value)];

    const wasAllProvidersSelected = selectedProviders.length === 0;

    if (newProviders.length === 1 && newProviders[0] === 0) {
      onProvidersChange([]);
      return;
    }

    if (wasAllProvidersSelected && newProviders.includes(0)) {
      const filteredProviders = newProviders.filter((id) => id !== 0);
      onProvidersChange(filteredProviders);
      return;
    }

    if (newProviders.includes(0) && newProviders.length > 1) {
      onProvidersChange([]);
      return;
    }

    onProvidersChange(newProviders);
  };

  const options: SelectOption[] = [
    { value: 0, label: "All Providers" },
    ...providers.map((provider) => ({
      value: provider.id,
      label: provider.name,
    })),
  ];

  return (
    <Select
      label="Providers"
      multiple
      width={width}
      options={options}
      value={selectedProviders.length === 0 ? [0] : selectedProviders}
      onChange={handleChange}
      onOpen={onOpen}
      onClose={onClose}
      loading={loading}
    />
  );
};

export default ProvidersFilter;
